import { Injectable } from '@angular/core';
import { Router, CanDeactivate, CanActivate, CanLoad, ActivatedRouteSnapshot, RouterStateSnapshot, Route } from '@angular/router';
import { Observable } from 'rxjs';
import { OrderStep1Component } from '../../components/order-step-1/order-step-1.component';
import { AuthorizationService, OrderService } from '../services';
import { ToastrService } from 'ngx-toastr';


export interface DeactivationGuard {
    canDeactivate(): Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable({
    providedIn: 'root'
})
export class OrderStep1Guard implements CanDeactivate<OrderStep1Component>, CanActivate, CanLoad {

    constructor(
        private router: Router,
        private authService: AuthorizationService,
        private orderService: OrderService,
        private toastr: ToastrService) {
    }

    canDeactivate(component: OrderStep1Component): Observable<boolean> | Promise<boolean> | boolean {
        if (component.orderStep1Form.touched && component.orderStep1Form.dirty) {
            return confirm(`Are you sure you want to navigate away and discard your changes?`);
        }
        return true;
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        return this.checkAccess();
    }

    canLoad(state: Route): boolean {
        return this.checkAccess();
    }

    private checkAccess(): boolean {
        let hasAccess = true;
        if (!this.authService.hasPermission(this.orderService.PERMISSION_CAN_READ_ORDER)) {
            hasAccess = false;
        }
        return hasAccess;
    }
}
